import { Grid, Tooltip} from "@mui/material";

export function getPharmaorderStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        executivename:{
            name:'executivename',
            label:'Executive Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        ordervalue:{
            name:'ordervalue',
            label:'Order Value',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'double'
        },
        dispatchdate:{
            name:'dispatchdate',
            label:'Dispatch Date',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        partyname:{
            name:'partyname',
            label:'Party Name',
            value:'',
            error:false,
            errorMessage:'You must enter Party Name',
            required:true,
            fieldtype:'string'
        },
        partyid:{
            name:'partyid',
            label:'Party Id',
            value:'',
            error:false,
            errorMessage:'You must enter Party Id',
            required:true,
            fieldtype:'bodynamiclist'
        },
        orderid:{
            name:'orderid',
            label:'Order Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        orderstatus:{
            name:'orderstatus',
            label:'Status',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'list'
        },
        popath:{
            name:'popath',
            label:'PO Path',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        poid:{
            name:'poid',
            label:'PO Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'You must enter Business Id',
            required:true,
            fieldtype:'ID'
        },
        comment:{
            name:'comment',
            label:'Comment',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        title:{
            name:'title',
            label:'Title',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        accountsapproved:{
            name:'accountsapproved',
            label:'Accounts Approved',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'boolean'
        },
        mdapproved:{
            name:'mdapproved',
            label:'MD Approved',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'boolean'
        },
        subtotal:{
            name:'subtotal',
            label:'Sub Total',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'double'
        },
        gstamount:{
            name:'gstamount',
            label:'GST Amount',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'double'
        },
        advance:{
            name:'advance',
            label:'Advance',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        submitdate:{
            name:'submitdate',
            label:'Submit Date',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        deliverydate:{
            name:'deliverydate',
            label:'Delivery Date',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        executiveid:{
            name:'executiveid',
            label:'Executive Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'subtotal', headerName: 'Sub Total', width:150 },
        { field: 'gstamount', headerName: 'GST Amount', width:150 },
        { field: 'advance', headerName: 'Advance', width:150 },
        { field: 'submitdate', headerName: 'Submit Date', width:150 },
        { field: 'deliverydate', headerName: 'Delivery Date', width:150 },
        { field: 'executiveid', headerName: 'Executive Id', width:150 },
        { field: 'orderid', headerName: 'Order Id', width:20 },
        { field: 'partyname', headerName: 'Party Name', width:150 },
        { field: 'executivename', headerName: 'Executive Name', width:100 },
        { field: 'ordervalue', headerName: 'Order Value', width:100 },
        { field: 'dispatchdate', headerName: 'Dispatch Date', width:100 },
        { field: 'orderstatus', headerName: 'Status', width:100 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['comment']:{
          ...formValues['comment'],
          value:data.comment,
        },['title']:{
          ...formValues['title'],
          value:data.title,
        },['accountsapproved']:{
          ...formValues['accountsapproved'],
          value:data.accountsapproved,
        },['mdapproved']:{
          ...formValues['mdapproved'],
          value:data.mdapproved,
        },['subtotal']:{
          ...formValues['subtotal'],
          value:data.subtotal,
        },['gstamount']:{
          ...formValues['gstamount'],
          value:data.gstamount,
        },['advance']:{
          ...formValues['advance'],
          value:data.advance,
        },['submitdate']:{
          ...formValues['submitdate'],
          value:data.submitdate,
        },['deliverydate']:{
          ...formValues['deliverydate'],
          value:data.deliverydate,
        },['executiveid']:{
          ...formValues['executiveid'],
          value:data.executiveid,
        },['orderid']:{
          ...formValues['orderid'],
          value:data.orderid,
        },['partyname']:{
          ...formValues['partyname'],
          value:data.partyname,
        },['executivename']:{
          ...formValues['executivename'],
          value:data.executivename,
        },['ordervalue']:{
          ...formValues['ordervalue'],
          value:data.ordervalue,
        },['dispatchdate']:{
          ...formValues['dispatchdate'],
          value:data.dispatchdate,
        },['partyid']:{
          ...formValues['partyid'],
          value:data.partyid,
        },['orderstatus']:{
          ...formValues['orderstatus'],
          value:data.orderstatus,
        },['popath']:{
          ...formValues['popath'],
          value:data.popath,
        },['poid']:{
          ...formValues['poid'],
          value:data.poid,
        },
      })
}